export default class PubSub {
    constructor() {
        this.events = {};
    }

    // Returns a zero-arg unsubscribe closure which detaches the callback.
    // Safe to call more than once (subsequent calls are no-ops).
    subscribe(event, callback) {

        let self = this;

        if(!self.events.hasOwnProperty(event)) {
            self.events[event] = [];
        }

        self.events[event].push(callback);

        return () => {
            const callbacks = self.events[event];
            if (!callbacks) return;
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }

    publish(event, data = {}) {

        let self = this;

        if(!self.events.hasOwnProperty(event)) {
            return [];
        }

        // Iterate a snapshot: a callback may unsubscribe (itself or a sibling) while we
        // publish — eg. a state change that destroys a component — and splicing the live
        // array mid-iteration would skip the following subscriber.
        return [...self.events[event]].map(callback => callback(data));
    }


}